import styled from "styled-components";
import CenteredContainer from "./CenteredContainer";

const HeroContainer: any = styled(CenteredContainer)`
  margin-top: 65px;
`;

export default HeroContainer;
